let modalStack: string[] = [];

export const registerModal = (id: string) => {
    // Проверяем, не зарегистрирована ли модалка уже
    if (modalStack.includes(id)) {
        console.log('[modalHistory] Модалка уже зарегистрирована, пропускаем:', id);
        return () => {
            // Cleanup функция для уже зарегистрированной модалки
            modalStack = modalStack.filter(modalId => modalId !== id);
        };
    }
    
    modalStack.push(id);
    console.log('[modalHistory] Модалка зарегистрирована:', id);
    console.log('[modalHistory] Текущий стек:', modalStack);
    
    // Добавляем запись в историю
    const modalState = { modalOpen: true, modalId: id };
    window.history.pushState(modalState, '', window.location.href);
    
    return () => {
        console.log('[modalHistory] Модалка удаляется из стека:', id);
        modalStack = modalStack.filter(modalId => modalId !== id);
        console.log('[modalHistory] Текущий стек после удаления:', modalStack);
    };
};

export const isLastModal = (id: string): boolean => {
    const isLast = modalStack.length > 0 && modalStack[modalStack.length - 1] === id;
    console.log('[modalHistory] Проверка isLastModal для', id, ':', isLast);
    console.log('[modalHistory] Текущий стек:', modalStack);
    return isLast;
};

export const getModalStackIndex = (id: string): number => {
    const index = modalStack.indexOf(id);
    return index >= 0 ? index : Math.max(modalStack.length - 1, 0);
};
